import { createSlice } from '@reduxjs/toolkit';
import { CHAT_FILTER } from '../Helpers/Chat/Constant';

const initialState = {
    active: CHAT_FILTER.ALL,
};

const chatFilter = createSlice({
    name: 'chatFilter',
    initialState,
    reducers: {
        setChatFilter(state, action) {
            state.active = action.payload;
        },
        clearChatFilter(state) {
            state.active = CHAT_FILTER.ALL;
        },
    },
});

export const { setChatFilter, clearChatFilter } = chatFilter.actions;
export default chatFilter.reducer;
